import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Ticket({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Ticket.Outline {...props} /> : <Ticket.Solid {...props} />;
}

Ticket.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M14.5996 9.50366C14.5996 9.08945 14.2638 8.75366 13.8496 8.75366C13.4354 8.75366 13.0996 9.08945 13.0996 9.50366V14.3247C13.0996 14.7389 13.4354 15.0747 13.8496 15.0747C14.2638 15.0747 14.5996 14.7389 14.5996 14.3247V9.50366Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M5.29892 3.25C3.07281 3.25 1.2512 5.0341 1.25104 7.25656L1.25 9.93456C1.24992 10.1335 1.32891 10.3244 1.46957 10.4651C1.61023 10.6058 1.80104 10.6849 2 10.6849C2.84009 10.6849 3.42668 11.2716 3.42668 12.001C3.42668 12.7687 2.80034 13.4006 2 13.4006C1.58579 13.4006 1.25 13.7364 1.25 14.1506V16.7431C1.25 18.9656 3.07047 20.75 5.29787 20.75H18.7021C20.9295 20.75 22.75 18.9656 22.75 16.7431V14.1506C22.75 13.7364 22.4142 13.4006 22 13.4006C21.1997 13.4006 20.5733 12.7687 20.5733 12.001C20.5733 11.2329 21.2001 10.6004 22 10.6004C22.199 10.6004 22.3898 10.5213 22.5304 10.3806C22.6711 10.2399 22.7501 10.0491 22.75 9.85009L22.749 7.25655C22.7488 5.0341 20.9272 3.25 18.7011 3.25H5.29892ZM2.75104 7.25686C2.75104 5.88064 3.88307 4.75 5.29892 4.75H13.0996V6.67024C13.0996 7.08446 13.4354 7.42024 13.8496 7.42024C14.2638 7.42024 14.5996 7.08446 14.5996 6.67024V4.75H18.7011C20.1169 4.75 21.249 5.88094 21.249 7.25716L21.2497 9.19628C19.9995 9.5229 19.0733 10.6472 19.0733 12.001C19.0733 13.3553 19.9999 14.4786 21.25 14.8049V16.7431C21.25 18.1195 20.1189 19.25 18.7021 19.25H14.5996V17.7603C14.5996 17.346 14.2638 17.0103 13.8496 17.0103C13.4354 17.0103 13.0996 17.346 13.0996 17.7603V19.25H5.29787C3.88114 19.25 2.75 18.1195 2.75 16.7431V14.8049C4.00011 14.4786 4.92668 13.3553 4.92668 12.001C4.92668 10.6199 3.9792 9.57965 2.75026 9.27572L2.75104 7.25686Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Ticket.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          opacity="0.4"
          d="M13.7505 10.203V8.18318C13.354 8.18318 13.0251 7.86377 13.0251 7.47859V5.07356C13.0251 4.7532 12.764 4.50049 12.4352 4.50049H5.7911C3.70213 4.50049 2 6.153 2 8.18318V10.6155C2 10.8043 2.07737 10.9828 2.21277 11.1143C2.34816 11.2449 2.53191 11.3201 2.72534 11.3201C3.46035 11.3201 4.02128 11.8274 4.02128 12.4944C4.02128 13.1905 3.45068 13.7448 2.73501 13.7533C2.33849 13.7533 2 14.0257 2 14.4203V16.8262C2 18.8555 3.70213 20.4995 5.78143 20.4995H12.4352C12.764 20.4995 13.0251 20.245 13.0251 19.9265V17.8963C13.0251 17.5027 13.354 17.1917 13.7505 17.1917V15.3701C13.354 15.3701 13.0251 15.0497 13.0251 14.6655V10.9076C13.0251 10.5224 13.354 10.203 13.7505 10.203Z"
          className="icon-secondary"
        />
        <path
          d="M19.9787 12.4948C19.9787 13.19 20.559 13.7443 21.265 13.7537C21.6615 13.7537 22 14.0262 22 14.4113V16.8258C22 18.8559 20.3075 20.5 18.2186 20.5H15.0658C14.7466 20.5 14.4758 20.2454 14.4758 19.926V17.8967C14.4758 17.5022 14.1567 17.1921 13.7505 17.1921V15.3705C14.1567 15.3705 14.4758 15.0502 14.4758 14.6659V10.9081C14.4758 10.522 14.1567 10.2035 13.7505 10.2035V8.1827C14.1567 8.1827 14.4758 7.86328 14.4758 7.4781V5.07401C14.4758 4.75366 14.7466 4.5 15.0658 4.5H18.2186C20.3075 4.5 22 6.14406 22 8.1733V10.5407C22 10.7286 21.9226 10.9081 21.7872 11.0387C21.6518 11.1702 21.4681 11.2453 21.2747 11.2453C20.559 11.2453 19.9787 11.81 19.9787 12.4948Z"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
